import type { ManagementTranslations } from '../en-US/management.translations';

export const managementTranslations: ManagementTranslations = {
  title: 'Gestão BiteCritic',
  dashboard: 'Painel de Controlo',
  users: 'Gestão de Utilizadores',
  settings: 'Definições',
  foods: {
    title: 'Gestão de Alimentos',
    createNew: 'Adicionar Novo Alimento',
    id: 'ID',
    name: 'Nome',
    category: 'Categoria',
    country: 'País',
    status: 'Estado',
    createdAt: 'Criado em',
    actions: 'Ações',
    noFoodsFound: 'Nenhum alimento encontrado',
    searchPlaceholder: 'Pesquisar alimentos...',
    allStatuses: 'Todos os Estados',
    allCategories: 'Todas as Categorias',
    sortNewest: 'Mais Recentes Primeiro',
    sortOldest: 'Mais Antigos Primeiro',
    sortNameAZ: 'Nome A-Z',
    sortNameZA: 'Nome Z-A',
    showing: 'A mostrar de {{from}} a {{to}} de {{total}} alimentos',
    confirmDelete: 'Tem a certeza que deseja eliminar este alimento?',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    createFood: 'Criar Novo Alimento',
    editFood: 'Editar Alimento',
    viewFood: 'Ver Detalhes do Alimento',
    namePlaceholder: 'Introduzir nome do alimento',
    descriptionPlaceholder: 'Introduzir descrição do alimento',
    selectCategory: 'Selecionar uma categoria',
    selectCountry: 'Selecionar um país',
    selectStatus: 'Selecionar um estado',
    imageUrl: 'URL da imagem',
    imageUrlPlaceholder: 'Introduzir URL da imagem',
    imagePreview: 'Pré-visualização da imagem',
    rowsPerPage: '{{count}} por página',
    translations: 'Traduções',
    description: 'Descrição',
    formatJson: 'Formatar JSON',
    jsonPlaceholder: 'Introduzir dados do alimento em formato JSON',
    jsonInstructions: 'Instruções de Formato JSON',
    jsonInstructionName: 'O nome é obrigatório e deve ser uma string',
    jsonInstructionCategory: 'CategoryId é obrigatório e deve ser um número',
    jsonInstructionCountry: 'CountryId é opcional e deve ser um número',
    jsonInstructionStatus: 'O estado deve ser um dos seguintes',
    jsonInstructionTranslations:
      'As traduções devem ser um registo de códigos de idioma para objetos de tradução',
    jsonUpdateError: 'Erro ao atualizar {{field}}: {{error}}',
    hideFilters: 'Ocultar Filtros',
    showFilters: 'Mostrar Filtros',
    totalItems: '{{count}} itens no total',
    aiPrompt: {
      title: 'Gerar Dados de Alimentos com IA',
      description: 'Usar IA para ajudar a gerar dados de alimentos',
      inputLabel: 'Nome do Alimento',
      inputPlaceholder: 'Introduzir um nome de alimento',
      buttonText: 'Gerar com IA',
      copyPrompt: 'Copiar Prompt',
      openInChatGPT: 'Abrir no ChatGPT',
      promptCopied: 'Prompt copiado para a área de transferência!',
      instructions: 'Instruções:',
      step1: '1. Introduzir um nome de alimento',
      step2: '2. Clicar em "Gerar com IA" ou copiar o prompt',
      step3: '3. Colar o prompt no ChatGPT ou clicar em "Abrir no ChatGPT"',
      step4:
        '4. Copiar a resposta JSON e usá-la para criar um novo item de alimento',
    },
  },
  languages: {
    en: 'Inglês',
    nl: 'Holandês',
    tr: 'Turco',
    de: 'Alemão',
    fr: 'Francês',
    es: 'Espanhol',
    it: 'Italiano',
    pt: 'Português',
  },
};

export default managementTranslations;
